{
  "list": {
    "attributes": {
      "friendlyName": "Name",
      "type": "Typ",
      "serialNumber": "Seriennummer",
      "firmwareVersion": "Firmware-Version",
      "hardwareVersion": "Hardware-Version",
      "state": "Status",
      "createdAt": "Erstellt am",
      "connectivity": {
        "name": "Konnektivität",
        "connected": {
          "lessThan": "Die letzte Verbindung des Geräts zur Plattform liegt weniger als {duration} zurück.",
          "greaterThan": "Die letzte Verbindung des Geräts zur Plattform liegt mehr als {duration} zurück."
        },
        "duration": {
          "seconds": "{count} Sekunden | {count} Sekunde | {count} Sekunden",
          "minutes": "{count} Minuten | {count} Minute | {count} Minuten",
          "hours": "{count} Stunden | {count} Stunde | {count} Stunden"
        }
      },
      "metastatus": {
        "name": "Metastatus",
        "status": {
          "success": "Alle letzten Vorgänge des Geräts waren erfolgreich.",
          "mixed": "Mindestens einer der letzten Vorgänge des Geräts ist fehlgeschlagen.",
          "error": "Alle letzten Vorgänge des Geräts sind fehlgeschlagen."
        }
      },
      "sector": "Sektor",
      "actionInProgress": "Aktionen in Bearbeitung",
      "certificateExpirationRange": "Zertifikat"
    }
  },
  "stateValue": {
    "PREPROVISIONED": "Vorab bereitgestellt",
    "REGISTERED": "registriert"
  },
  "import": {
    "title": "Importieren",
    "text": "Importieren",
    "header": {
      "text": "Vorab bereitgestellte Geräte importieren"
    },
    "clickToUpload": "Klicken, um hochzuladen",
    "orDragAndDrop": "oder nur eine .ZIP-Datei per Drag-and-drop ziehen und ablegen",
    "action": {
      "report": "Analysieren",
      "execution": "Importieren"
    },
    "inProgress": {
      "report": "Analyse läuft...",
      "execution": "Import läuft..."
    },
    "results": {
      "report": {
        "total": "Keine Geräte erkannt | 1 Gerät erkannt | {count} Geräte erkannt",
        "succeed": {
          "exist": "Validierte Geräte zum Aktualisieren:",
          "new": "Validierte Geräte zum Erstellen:"
        },
        "failed": "Fehlerhafte Geräte:"
      },
      "execution": {
        "total": "Keine Geräte verarbeitet | 1 Gerät verarbeitet | {count} Geräte verarbeitet",
        "succeed": {
          "exist": "Aktualisierte Geräte:",
          "new": "Erstellte Geräte:"
        },
        "failed": "Fehlerhafte Geräte:"
      }
    },
    "validation": {
      "fileMandatory": "Die Datei muss eine .ZIP-Datei sein",
      "fileEmpty": "Die .ZIP-Datei darf nicht leer sein"
    }
  },
  "form": {
    "description": {
      "title": "Beschreibung",
      "idCard": {
        "title": "ID-Karte",
        "attributes": {
          "name": "Name",
          "type": "Typ",
          "model": "Modell",
          "serialNumber": "Seriennummer",
          "hardwareVersion": "Hardware-Version",
          "manufacturer": "Hersteller",
          "sector": "Sektor"
        }
      },
      "state": {
        "title": "Status",
        "attributes": {
          "state": "Status",
          "firstConnection": "Erste Verbindung",
          "lastConnection": "Letzte Verbindung",
          "batteryStatus": "Batteriestatus",
          "lastChange": "Letzte Änderung",
          "configurationApplicationDate": "Datum der Parametrierungsanwendung",
          "lastRebootDate": "Datum des letzten Neustarts",
          "firstCommissioningDate": "Datum der ersten Inbetriebnahme",
          "certificateExpirationDate": "Ablaufdatum des Zertifikats",
          "firmwareVersion": "Firmware-Version",
          "latestFirmwareUpdate": "Letztes Firmware-Update",
          "lastCertificateUpdate": "Letzte Zertifikatsaktualisierung",
          "lastSynchronisation": "Letzte Synchronisierung des Geräts:",
          "lastDisconnectionDate": "Datum der letzten Trennung"
        }
      },
      "connectivity": {
        "title": "Konnektivität",
        "communication": "Kommunikation",
        "simCard": "SIM-Karte",
        "attributes": {
          "antenna": "Antenne",
          "mobileNetwork": "Mobilfunknetz",
          "gsmFrequencyBand": "GSM-Frequenzband",
          "communicationProtocol": "Kommunikationsprotokoll",
          "accessPointName": "Zugangspunktname (APN)",
          "userName": "Benutzername"
        },
        "status": "Verbindungsstatus"
      },
      "geolocation": {
        "title": "Standortbeschreibung",
        "attributes": {
          "address": "Adresse",
          "latlong": "Breite: {latitude} - Länge: {longitude}",
          "status": "Geolokalisierungsstatus"
        }
      },
      "characteristics": {
        "title": "Eigenschaften"
      }
    },
    "configuration": {
      "title": "Parametrierung",
      "information": {
        "configurationType": {
          "label": "Parametrierungstyp",
          "SELF_SUPPORTING": "Eigenständig",
          "GLOBAL_AND_SPECIFIC": "Global + spezifisch"
        },
        "selfSupportingVersion": "Eigenständige Version",
        "globalVersion": "Globale Version",
        "specificVersion": "Spezifische Version",
        "configurationOrigin": "Herkunft der Parametrierung",
        "lastUpdate": "Zuletzt aktualisiert"
      },
      "operations": {
        "title": "Betrieb"
      },
      "upload": {
        "userInformation": {
          "title": "Parametrierung hochladen",
          "description": "Diese Parametrierung ist nur für dieses Gerät verfügbar."
        },
        "error": {
          "invalidFileType": "Die Datei muss im JSON- oder JWT-Format vorliegen.",
          "fileSize": "Die Parametrierungsdatei muss kleiner als 750 MB sein.",
          "emptyFile": "Die Parametrierungsdatei darf nicht leer sein.",
          "fileAlreadyExist": "Diese Parametrierungsdatei ist für dieses Gerät bereits vorhanden."
        },
        "title": "Parametrierung hochladen",
        "confirm": {
          "title": "Hochladen der Parametrierung abbrechen",
          "message": "Möchten Sie das Hochladen der Parametrierung wirklich abbrechen?\nAlle Daten gehen dabei verloren."
        },
        "form": {
          "title": "Parametrierungsinformationen",
          "versionName": "Versionsname",
          "version": "Version",
          "type": "Typ"
        },
        "buttonTooltip": "Eine Parametrierung hochladen",
        "success": "Das Hochladen der Parametrierung war erfolgreich"
      },
      "update": {
        "title": "Parametrierungsaktualisierung",
        "warning": "Für das Gerät ist bereits ein Vorgang desselben Typs geplant oder wird ausgeführt",
        "scheduling": {
          "title": "Terminplanung",
          "label": "Aktualisierung geplant",
          "placeholder": "Aktualisierungsdatum auswählen"
        },
        "configurationSelection": {
          "title": "Parametrierung",
          "radio": {
            "specific": "Spezifisch",
            "globalAndSpecific": "Global und spezifisch"
          },
          "label": "Wählen Sie eine Parametrierung aus der Liste unten aus",
          "placeholder": "Eine Parametrierung auswählen",
          "specific": "Spezifische Parametrierung",
          "global": "Globale Parametrierung"
        },
        "instantSending": {
          "label": "Sofortige Übermittlung",
          "tooltip": "Übertragung des Vorgangs an das Gerät so schnell wie möglich."
        },
        "cancel": {
          "confirm": {
            "title": "Abbruch der Parametrierungsaktualisierung",
            "message": "Möchten Sie das Aktualisieren der Parametrierung wirklich abbrechen?\nAlle Daten gehen dabei verloren."
          }
        }
      },
      "browse": {
        "selfSupporting": "Die eigenständigen Parametrierungen durchsuchen",
        "specific": "Spezifische Parametrierungen durchsuchen"
      },
      "list": {
        "title": {
          "selfSupporting": "Eigenständige Parametrierungen",
          "specific": "Spezifische Parametrierungen"
        },
        "search": {
          "placeholder": "Nach Versionsname oder Version suchen"
        },
        "noConfiguration": "Keine Parametrierung gefunden",
        "columns": {
          "versionName": "Versionsname",
          "version": "Version",
          "uploadedDate": "Datum des Hochladens"
        },
        "periodPicker": {
          "placeholder": "Einen Zeitraum auswählen"
        }
      },
      "delete": {
        "selectedConfigurations": "Keine Parametrierungen ausgewählt | {count} Parametrierung ausgewählt | {count} Parametrierungen ausgewählt",
        "confirm": {
          "title": "Keine Parametrierungen ausgewählt | Parametrierung löschen | Parametrierungen löschen",
          "message": "Keine Parametrierungen ausgewählt | Möchten Sie die ausgewählte Parametrierung wirklich löschen? | Möchten Sie die ausgewählten Parametrierungen wirklich löschen?"
        }
      }
    },
    "dataviz": {
      "title": "Datenvisualisierung",
      "day": "Tag",
      "week": "Woche",
      "month": "Monat",
      "quarter": "Quartal",
      "newChart": "Ziehen und legen Sie Daten hier ab, um ein neues Diagramm zu erstellen.",
      "noData": "Keine Daten"
    },
    "firmware": {
      "title": "Firmware",
      "state": {
        "attributes": {
          "firmwareVersion": "Version",
          "latestFirmwareUpdate": "Zuletzt aktualisiert"
        }
      },
      "information": {
        "attributes": {
          "latestFirmwareUpdate": "Zuletzt aktualisiert",
          "firmwareUpdateSource": "Herkunft",
          "firmwareUpdateSourceOption": {
            "mobileApp": "Mobile App",
            "factory": "Werk"
          }
        }
      },
      "updateFirmware": "Firmware aktualisieren"
    },
    "logs": {
      "title": "Protokolle",
      "lastOperationReportUpdateDate": {
        "label": "Datum des letzten Hochladens des Betriebsberichts"
      },
      "noLogsFound": "Keine Protokolle gefunden"
    },
    "additionalMetadata": {
      "title": "Zusätzliche Metadaten",
      "options": {
        "title": "Optionen",
        "processControl": "Programmbaustein",
        "pumpingStation": "Pumpstationen",
        "webServer": "WEB Server",
        "webMimicDiagram": "Übersicht grafische Darstellung der Website",
        "ipBackup": "IP-Backup ADSL/GSM",
        "iecSlave": "IEC60870-5-104 Slave",
        "externalControlLiftStation": "Externe Steuerung der Hebeanlage",
        "pumpingOptimization": "Pumpenoptimierung",
        "dataPoints": "Anzahl der Datenpunkte: {value}",
        "ioModules": "Anzahl der E/A-Module: {value}",
        "comModules": "Anzahl der COM-Module: {value}",
        "calendars": "Anzahl der Kalender: {value}",
        "schedules": "Anzahl der Zeitpläne: {value}",
        "objects": "Anzahl der Objekte: {value}",
        "allowedLocalPost": "Fernwirkstationen: {value}",
        "licenceExpirationDate": "Ablaufdatum der Lizenz: {value}",
        "licenceId": "Lizenznummer: {value}"
      },
      "communicationModules": {
        "title": "Kommunikationsmodule"
      },
      "modules": {
        "location": "Standort",
        "module": "Modul"
      },
      "ioModules": {
        "title": "Module E/A"
      },
      "networkInterfaceCardExtensions": {
        "title": "Netzwerkkarten-Erweiterung(en)"
      },
      "ioCardExtensions": {
        "title": "E/A-Karten-Erweiterung(en)"
      },
      "modemCardExtensions": {
        "title": "Modemkarten-Erweiterung(en)"
      },
      "comments": {
        "title": "Kommentare"
      }
    },
    "certificate": {
      "title": "Zertifikat",
      "information": {
        "title": "Zertifikat",
        "attributes": {
          "certificateExpirationDate": "Gültigkeitsdatum des Zertifikats",
          "lastCertificateUpdate": "Letzte Aktualisierung des Zertifikats",
          "origin": "Herkunft des Zertifikats",
          "origins": {
            "mobileApplication": "Mobile Anwendung",
            "lxConnect": "LX CONNECT"
          }
        }
      }
    }
  },
  "empty": "Kein Gerät gefunden",
  "lifeCycleState": {
    "preprovisioned": "Vorab bereitgestellt",
    "registered": "Registriert",
    "activated": "Aktiviert",
    "disabled": "Deaktiviert",
    "locked": "Gesperrt"
  },
  "filters": {
    "searchByNameOrSerialNumber": "Nach Name oder Seriennummer suchen",
    "compatibilityQuickFilters": {
      "allDevices": "Alle Geräte",
      "compatibleDevices": "Kompatible Geräte",
      "incompatibleDevices": "Inkompatible Geräte"
    },
    "deviceType": "Typ",
    "selectionQuickFilters": {
      "allDevices": "Alle Geräte",
      "selectedDevices": "Ausgewählte Geräte",
      "unselectedDevices": "Nicht ausgewählte Geräte"
    },
    "lifecycleState": "Status",
    "connectivity": {
      "label": "Konnektivität",
      "type": "Geräteverbindungstyp",
      "status": "Status",
      "SHORT_LIVED": "Abfrage",
      "GOOD": "Weniger als 24 Stunden",
      "WARN": "Mehr als 24 Stunden",
      "ERROR": "Mehr als 72 Stunden",
      "empty": "Kein Status verfügbar",
      "PERSISTENT": "Dauerhaft",
      "ONLINE": "Verbunden",
      "OFFLINE": "Getrennt"
    },
    "ranges": {
      "label": "Bereich"
    },
    "firmwareVersion": {
      "unknown": {
        "label": "Unbekannt"
      }
    }
  },
  "fleet": {
    "cancelSelection": "Auswahl abbrechen",
    "selectedDevices": "Keine Geräte ausgewählt | {count} Gerät ausgewählt | {count} Geräte ausgewählt",
    "addToFleet": "Zu einer Flotte hinzufügen",
    "removeFromFleet": "Aus der Flotte entfernen"
  },
  "deviceFound": "Keine Geräte gefunden | {count} Gerät gefunden | {count} Geräte gefunden",
  "action": {
    "enable": "Gerät aktivieren",
    "disable": "Gerät deaktivieren",
    "confirm": {
      "title": "Gerät deaktivieren?",
      "description": "Möchten Sie dieses Gerät wirklich deaktivieren? Diese Aktion verhindert jegliche Kommunikation mit der Plattform und alle derzeit laufenden Vorgänge werden abgebrochen.",
      "disable": "Deaktivieren"
    },
    "button": {
      "enable": "Aktivieren",
      "disable": "Deaktivieren"
    },
    "delete": {
      "tooltip": "Gerät löschen",
      "confirm": {
        "title": "Gerätelöschung",
        "message": "Das Löschen eines Geräts führt zu einer dauerhaften Löschung aller seiner Daten, Vorgänge und Telemetriedaten."
      }
    }
  },
  "cartography": {
    "title": "Kartografie",
    "deviceMapTile": {
      "button": {
        "seeDevice": "Gerät anzeigen"
      }
    },
    "devicesMap": {
      "noDevices": "Keine Geräte zum Anzeigen"
    }
  },
  "globalConfiguration": {
    "automaticRenewalDelay": {
      "information": {
        "title": "Verzögerung der automatischen Zertifikatsverlängerung",
        "body": "Legt fest, wie lange vor dem Ablauf das Gerätezertifikat automatisch verlängert wird."
      },
      "label": "Verzögerung der automatischen Zertifikatsverlängerung",
      "values": {
        "nDay": "1 Tag | {n} Tage",
        "nMonth": "1 Monat | {n} Monate",
        "nYear": "1 Jahr | {n} Jahre"
      },
      "custom": {
        "label": "Benutzerdefiniert",
        "unit": "Tag | Tage"
      },
      "error": {
        "required": "Die Verzögerung der automatischen Verlängerung ist erforderlich",
        "minMax": "Die Verzögerung bei der automatischen Verlängerung muss zwischen {min} und {max} betragen"
      }
    },
    "pollingFrequency": {
      "information": {
        "title": "Abfragehäufigkeit",
        "body": "Definiert das Zeitintervall zwischen zwei Übertragungen vom Gerät zur Plattform."
      },
      "label": "Abfragehäufigkeit",
      "values": {
        "nMinute": "1 Minute | {n} Minuten",
        "nHour": "1 Stunde | {n} Stunden"
      },
      "custom": {
        "label": "Benutzerdefiniert",
        "unit": "Minute | Minuten"
      },
      "error": {
        "required": "Die Abfragehäufigkeit ist erforderlich",
        "minMax": "Die Abfragehäufigkeit muss zwischen {min} und {max} liegen"
      }
    }
  }
}
